module.exports = __webpack_public_path__ + "img/Wp_2076.a0ece9aa.png";